import React from "react";
import { useEffect } from 'react';

export default function AdminClientCard() {
    useEffect(() => {
        document.title = `Delta M. Crm. ${window.captions.ClientCard}`;
    }, []);

    return;
}